/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Submit_TitleInputs */

const en_seo_submit_title = /** @type {(inputs: Seo_Submit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit`)
};

const zh_seo_submit_title = /** @type {(inputs: Seo_Submit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交`)
};

/**
* | output |
* | --- |
* | "Submit" |
*
* @param {Seo_Submit_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const seo_submit_title = /** @type {((inputs?: Seo_Submit_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Submit_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seo_submit_title(inputs)
	return zh_seo_submit_title(inputs)
});
export { seo_submit_title as "seo.submit.title" }